module.exports = __webpack_public_path__ + "static/media/DSC_2900.539b2475.jpg";